<template>
        
    <div class="card">
        <div class="card-body">

            <h4 
                class="card-title"
                :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                :style="($i18n.locale == 'ar') ? '' : 'text-align: left'">
                {{ $t('app.choose_contracts') }}
            </h4>
            <div class="col-md-12 text-center" style="padding:0">
                <span 
                    v-if="contractsLoading"
                    class="spinner-grow spinner-grow-sm mr-1" 
                    role="status" 
                    aria-hidden="true">
                </span>
                <select 
                    v-if="!contractsLoading"
                    id="transactionType"
                    class="form-control" 
                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                    v-model="row.contract_id"
                    v-on:change="onInputChange">
                    <option 
                        v-for="(row, idx) in contracts" 
                        :key="idx"
                        :value="row.id">
                        {{ ($i18n.locale == 'ar') ? row.ar.title : row.en.title }}
                    </option>
                </select>
            </div>
        </div>
    </div>
        
</template>

<script>
import iziToast from 'izitoast';

export default {
    namme: 'CardContract',
    props: [
        'contract_id'
    ],
    data(){
        return {
            auth: {
                access_token: ''
            },
            row: {
                contract_id: this.$props.contract_id
            },
            contracts: [],
            contractsLoading: true,
        }
    },
    mounted() {},
    created() {
        if(localStorage.getItem('access_token')) {
            this.auth.access_token = localStorage.getItem('access_token');
        }

        this.fetchData();
    },
    methods: {
        onInputChange(){
            const data = {
                contract_id: this.row.contract_id
            }
            this.$emit('contractChange', data);
        },

        fetchData() {
            this.contractsLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer ` + this.auth.access_token,
            };
            const options = {
                url: window.baseURL+'/contracts',
                method: 'GET',
                data: {},
                params: {
                    status: 'active',
                    paginate: 1000
                }
            }
            this.axios(options)
            .then(res => {
                this.contractsLoading = false;
                this.contracts = res.data.data.rows;
            })
            .catch(err => {
                this.contractsLoading = false;
                iziToast.warning({
                    icon: 'bx bx-angry',
                    title: '',
                    message: (err.response) ? err.response.data.message : ''+err
                });
            })
        },
    }
}
</script>
